/**
 * Pixel-art icons of the weapons for the weapon bar (the GDD has none): one grid per weapon id, drawn once into
 * a 16 × 16 image (centred), then shown scaled up without smoothing.
 */
import {
  WEAPON_BAZOOKA, WEAPON_GRENADE, WEAPON_PISTOL, WEAPON_SANDBAG, WEAPON_DRILL, WEAPON_MINE, WEAPON_WAVE, WEAPON_FLAMER,
  WEAPON_COCKTAIL, WEAPON_CRYO, WEAPON_ICE_MINE, WEAPON_METEOR, WEAPON_LASER, WEAPON_GEYSER, WEAPON_DOLL, WEAPON_REMOTE,
  WEAPON_JETPACK, WEAPON_BATTERY, WEAPON_ACID_BARREL, WEAPON_POWDER_BARREL, WEAPON_VOLCANO, WEAPON_ROOMBA,
} from '@invaders/game';

const PALETTE: Readonly<Record<string, string>> = {
  k: '#15151c', G: '#5a5f69', g: '#9aa0aa', w: '#f2f4f8', r: '#d83a2a', o: '#ff8a2a', y: '#ffd23f', f: '#ffb02e',
  b: '#3f7fd8', B: '#1f4f9f', c: '#a8e4f4', C: '#5fb4d8', n: '#8a5a2e', N: '#4a2a14', e: '#4f8a2e', E: '#86c45a',
  s: '#d6b85a', S: '#a88a3a', p: '#c69cff', P: '#8a5ad0', v: '#5fd35f', V: '#2e8a2e',
};

const ICONS: Readonly<Record<number, readonly string[]>> = {
  [WEAPON_BAZOOKA]: [
    '..kkkkkkkkkk....',
    '.kGeeeeeeeeGkkk.',
    'kGeEEEEEEEEeGrrk',
    'kGeeeeeeeeeeGrrk',
    '.kGGGGGGGGGGkkk.',
    '..kkkkGkkkkk....',
    '......kGk.......',
    '......kGk.......',
    '.......k........',
  ],
  [WEAPON_GRENADE]: [
    '.....kkk..',
    '....kGGGk.',
    '.....kGk.k',
    '....kkkkkk',
    '...keeeeek',
    '..keEeeeeek',
    '..keEeeeeek',
    '..keeeeeeek',
    '..keeeeeeek',
    '...keeeeek',
    '....kkkkk',
  ],
  [WEAPON_PISTOL]: [
    '.kkkkkkkkkkk.',
    'kGGGGGGGGGGGk',
    'kgggggggggggkk',
    'kGGGGGGGGGGGk',
    '.kkkkGGGkkkk.',
    '....kGGGk....',
    '...kGGGk.....',
    '...kGGGk.....',
    '..kGGGk......',
    '..kkkkk......',
  ],
  [WEAPON_SANDBAG]: [
    '....k..k....',
    '.....kk.....',
    '....kssk....',
    '...kssssk...',
    '..kssssssk..',
    '.kssssssssk.',
    '.ksSsssssskk',
    'kssssssssssk',
    'ksssssSssssk',
    'kssssssssssk',
    'ksSssssssssk',
    '.kssssssssk.',
    '..kkkkkkkk..',
  ],
  [WEAPON_DRILL]: [
    '...kkkkk.......',
    '..kyyyyyk......',
    '.kyfyyyyykkk...',
    'kyyyyyyyygggkk.',
    'kyyyyyyyyggggGk',
    'kyyyyyyyygggkk.',
    '.kyyyyyyykkk...',
    '..kyyyyyk......',
    '...kkkkk.......',
  ],
  [WEAPON_MINE]: [
    '......kk......',
    '.....krrk.....',
    '...kkkkkkkk...',
    '.kkGGGGGGGGkk.',
    'kGggggggggggGk',
    'kGGGGGGGGGGGGk',
    '.kkkkkkkkkkkk.',
  ],
  [WEAPON_WAVE]: [
    '......kkkk......',
    '....kkwwwbk.....',
    '...kwwbbbbbk....',
    '..kwbbkkkbbk....',
    '..kbbk...kbk....',
    '.kbbbk....k.....',
    '.kbbbbk.........',
    'kbbbbbbkk...kk..',
    'kbbbbbbbbkkkbbk.',
    'kbbbbbbbbbbbbbbk',
    'kBBBBBBBBBBBBBBk',
    'kkkkkkkkkkkkkkkk',
  ],
  [WEAPON_FLAMER]: [
    '..........ff..',
    '.........fyyf.',
    '........fyyof.',
    'kkkkkkk.foyf..',
    'kGGGGGGkff....',
    'kgggggggkkf...',
    'kGGGGGGkf.....',
    'kkkkGkkk......',
    '...kGk........',
    '...kGk........',
    '...kkk........',
  ],
  [WEAPON_COCKTAIL]: [
    '..ff....',
    '.fyof...',
    '..fo....',
    '..wk....',
    '..nk....',
    '.knnk...',
    'knnnnk..',
    'knNnnk..',
    'knnnnk..',
    'knnnnk..',
    'knnnnk..',
    'kkkkkk..',
  ],
  [WEAPON_CRYO]: [
    '.....kkk..',
    '....kGGGk.',
    '.....kGk.k',
    '....kkkkkk',
    '...kbbbbbk',
    '..kbcbwbcbk',
    '..kbbwwwbbk',
    '..kbcbwbcbk',
    '..kbbbbbbbk',
    '...kbbbbbk',
    '....kkkkk',
  ],
  [WEAPON_ICE_MINE]: [
    '......kk......',
    '.....kcck.....',
    '...kkkkkkkk...',
    '.kkCCCCCCCCkk.',
    'kCccccccccccCk',
    'kCCCCCCCCCCCCk',
    '.kkkkkkkkkkkk.',
  ],
  [WEAPON_METEOR]: [
    'c...........',
    '.c..........',
    '..c.c.......',
    '...c.c......',
    '....ckkkkkk.',
    '....kccccwck',
    '....kcwcccck',
    '....kcccccck',
    '....kccccwck',
    '....kcccccck',
    '....kkkkkkkk',
  ],
  [WEAPON_LASER]: [
    '..kkkkkkk.......',
    '.kpppppppkk.....',
    '.kpPPPPPPprrrrrr',
    '.kpppppppkk.....',
    '..kkkpkkk.......',
    '....kpk.........',
    '...kpk..........',
    '...kkk..........',
  ],
  [WEAPON_GEYSER]: [
    '.....wbw......',
    '....bwbwb.....',
    '.....bbb......',
    '......b.......',
    '.....bwb......',
    '.....bbb......',
    '....bbwbb.....',
    '.....bbb......',
    '.....bbb......',
    '....bbbbb.....',
    'nnnnbbbbbnnnnn',
    'NNNNNNNNNNNNNN',
  ],
  [WEAPON_DOLL]: [
    '....kkk.....',
    '...kpppk....',
    '...kpkpk..r.',
    '...kpppk.k..',
    '.kkkpppkkk..',
    'kpppppppppk.',
    '.kkkpppkkk..',
    '....kppk....',
    '...kpkkpk...',
    '...kpk.kpk..',
    '..kkk..kkk..',
  ],
  [WEAPON_REMOTE]: [
    '.....k',
    '....k.',
    '...k..',
    'kkkkkk',
    'kGGGGk',
    'kGrrGk',
    'kGGGGk',
    'kGyyGk',
    'kGGGGk',
    'kGbbGk',
    'kGGGGk',
    'kkkkkk',
  ],
  [WEAPON_BATTERY]: [
    '....kkkk....',
    '...kGggGk...',
    'kkkkkkkkkkkk',
    'kGggggggggGk',
    'kGgggkykgggk',
    'kGggkyykgggk',
    'kGgkyyyyykgk',
    'kGgggkyykggk',
    'kGgggkykgggk',
    'kGggggggggGk',
    'kGGGGGGGGGGk',
    'kkkkkkkkkkkk',
  ],
  [WEAPON_ACID_BARREL]: [
    '..kkkkkkkk..',
    '.kNnnnnnnNk.',
    'kNnnnnnnnnNk',
    'kGGGGGGGGGGk',
    'knnnvvvvnnnk',
    'knnvVVVVvnnk',
    'knnvVVVVvnnk',
    'knnnvvvvnnnk',
    'kGGGGGGGGGGk',
    'kNnnnnnnnnNk',
    '.kNnnnnnnNk.',
    '..kkkkkkkk..',
    '...v...vv...',
    '..vv....v...',
  ],
  [WEAPON_POWDER_BARREL]: [
    '.......yf...',
    '..kkkkkkk...',
    '.kNnnnnnnNk.',
    'kNnnnnnnnnNk',
    'kGGGGGGGGGGk',
    'knnnkkkknnnk',
    'knnkkkkkknnk',
    'knnkkkkkknnk',
    'knnnkkkknnnk',
    'kGGGGGGGGGGk',
    'kNnnnnnnnnNk',
    '.kNnnnnnnNk.',
    '..kkkkkkkk..',
  ],
  [WEAPON_VOLCANO]: [
    '......y.y.......',
    '.....f.o.f......',
    '......roo.......',
    '.....krrok......',
    '....kGrrrGk.....',
    '...kGGkrkGGk....',
    '..kGGGGkGGGGk...',
    '.kGGGGGGGkGGGk..',
    'kGGGGGGGGGGGGGk.',
    'kkkkkkkkkkkkkkk.',
  ],
  [WEAPON_ROOMBA]: [
    '...kkkkkkkk...',
    '.kkggggggggkk.',
    'kgggggkggkgggk',
    'kgggggkggkgggk',
    'kgggkggggggkgk',
    'kGgggkkkkkkggk',
    '.kGggggggggGk.',
    '..kkkkkkkkkk..',
  ],
  [WEAPON_JETPACK]: [
    '.kkkkkkkk.',
    'kGggggggGk',
    'kgGGkkGGgk',
    'kgGk..kGgk',
    'kgGk..kGgk',
    'kgGk..kGgk',
    'kGGk..kGGk',
    'kkkk..kkkk',
    '.fy....yf.',
    '.ff....ff.',
    '..f....f..',
  ],
};

const cache = new Map<number, string>();

/** The icon of `weapon` as an image URL (16 × 16), or '' if it has none. */
export function weaponIcon(weapon: number): string {
  const known = cache.get(weapon);
  if (known !== undefined) return known;
  const grid = ICONS[weapon];
  const url = grid ? gridIcon(grid) : '';
  cache.set(weapon, url);
  return url;
}

/** A pixel-art grid (one character per pixel, `.` transparent, colours of PALETTE) as a 16 × 16 image URL, centred. */
export function gridIcon(grid: readonly string[]): string {
  const canvas = document.createElement('canvas');
  canvas.width = 16;
  canvas.height = 16;
  const ctx = canvas.getContext('2d')!;
  const wide = Math.max(...grid.map((row) => row.length));
  const ox = Math.floor((16 - wide) / 2);
  const oy = Math.floor((16 - grid.length) / 2);
  grid.forEach((row, y) => {
    for (let x = 0; x < row.length; x++) {
      const color = PALETTE[row[x]];
      if (!color) continue;
      ctx.fillStyle = color;
      ctx.fillRect(ox + x, oy + y, 1, 1);
    }
  });
  return canvas.toDataURL();
}
